<template>
  <div class="afdc-mobile-nav">
    <ul class="afdc-nav" id="afdc-mobile-tabs" role="tablist">
      <li class="afdc-nav-item afdc-mobile-nav-item">
        <a id="afdc-mobile-search-tab" href="#afdc-mobile-search" role="tab" aria-controls="afdc-mobile-search" v-on:click.prevent="clickTab('search')" v-bind:class="{ 'afdc-mobile-nav-link': true, 'afdc-active': isTabActiveSearch }" v-bind:aria-selected="isTabActiveSearch ? 'true' : 'false'">
          <font-awesome-icon icon="search" class="afdc-fa-icon afdc-tab-icon"/>{{ $t('Search') }}
        </a>
      </li>
      <li class="afdc-nav-item afdc-mobile-nav-item">
        <a id="afdc-mobile-map-tab" href="#afdc-mobile-map" role="tab" aria-controls="afdc-mobile-map" v-on:click.prevent="clickTab('map')" v-bind:class="{ 'afdc-mobile-nav-link': true, 'afdc-active': isTabActiveMap}" v-bind:aria-selected="isTabActiveMap? 'true' : 'false'">
          <font-awesome-icon :icon="mapListViewIcon.icon" class="afdc-fa-icon afdc-tab-icon"/>{{ $t(mapListViewIcon.label) }}
        </a>
      </li>
      <li class="afdc-nav-item afdc-mobile-nav-item">
        <a id="afdc-mobile-more-tab" href="#" role="tab" aria-controls="afdc-mobile-more" v-on:click.prevent="clickTab('more')" v-bind:class="{ 'afdc-mobile-nav-link': true, 'afdc-active': isTabActiveMore}" v-bind:aria-selected="isTabActiveMore? 'true' : 'false'">
          <font-awesome-icon icon="plus" class="afdc-fa-icon afdc-tab-icon"/>{{ $t('More') }}
        </a>
      </li>
    </ul>

    <div class="afdc-tab-content" id="afdc-mobile-tabs-content">
      <div id="afdc-mobile-search" role="tabpanel" aria-labelledby="afdc-mobile-search-tab" v-bind:class="{ 'afdc-tab-pane': true, 'afdc-mobile-tab-pane': true, 'afdc-show': isTabActiveSearch, 'afdc-active': isTabActiveSearch }">
        <template v-if="$store.getters.getStationsError">
          <div class="afdc-stations-error">
            <p class="afdc-alert afdc-alert-warning"><em>{{ $store.getters.getStationsError }}</em></p>
          </div>
        </template>
        <template>
          <ev-level-help/>
          <div v-if="!isNpsFunded" class="afdc-row afdc-route-switch-row">
            <div class="afdc-col-10">
              <div class="afdc-station-route-switch">
                <router-link :to="{ name: 'FindNearestStations' }" event="" v-on:click.native.prevent="clickToggleMode('nearest')" :class="{ 'afdc-toggle-search':true, 'afdc-toggle-search-active':isNavActiveFindModeNearest }">
                  {{ $t('Find Stations') }}
                </router-link>
                <router-link :to="{ name: 'FindRouteStations' }" event="" v-on:click.native.prevent="clickToggleMode('route')" :class="{ 'afdc-toggle-search':true, 'afdc-toggle-search-active':isNavActiveFindModeRoute }">
                  {{ $t('Map a Route') }}
                </router-link>
              </div>
            </div>
          </div>
          <form v-on:submit.prevent="submitMobileFilters">
            <template v-if="isNavActiveFindModeNearest">
              <find-nearest-filters/>
            </template>
            <template v-if="isNavActiveFindModeRoute">
              <find-route-filters/>
            </template>
            <div class ="afdc-mobile-results-select">
              <div class="afdc-row">
                <select v-model="queryCountry" class="afdc-form-control afdc-custom-select">
                  <option v-for="option in countryOptions" v-bind:key="option.key" v-bind:value="option.key">
                    {{ option.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="afdc-custom-control afdc-custom-checkbox">
              <input type="checkbox" class="afdc-custom-control-input" v-model="queryAccess" v-bind:value="'private'" :id="'stationShowPrivate'">
              <label class="afdc-custom-control-label" :for="'stationShowPrivate'">{{ $t('Include private stations') }}</label>
            </div>
            <div class ="afdc-row afdc-mobile-results-btn">
              <button class="afdc-btn afdc-mobile-see-results-btn" type="submit">{{ $t('See results') }}</button>
            </div>
          </form>
        </template>
      </div>

      <div id="afdc-mobile-map" role="tabpanel" aria-labelledby="afdc-mobile-map-tab" v-bind:class="{ 'afdc-tab-pane': true, 'afdc-show': isTabActiveMap, 'afdc-active': isTabActiveMap}">
        <div v-if="isLoading" class="afdc-large-spinner-container">
          <div class="afdc-large-spinner"></div>
        </div>
        <div class="afdc-map-list-toggle-btn" v-if="hasResults">
          <div v-if="mapListView === 'map'" @click="toggleMapListView('list')" tabindex=0 @keyup.enter="toggleMapListView('list')" class="afdc-mobile-btn">
            <font-awesome-icon icon="list" class="afdc-fa-icon afdc-tab-icon"/>{{ $t('List') }}
          </div>
          <div v-if="mapListView === 'list'" @click="toggleMapListView('map')" tabindex=0 @keyup.enter="toggleMapListView('map')" class="afdc-mobile-btn">
            <font-awesome-icon icon="map-marker-alt"  class="afdc-fa-icon afdc-tab-icon"/>{{ $t('Map') }}
          </div>
        </div>
          <div v-if="mapListView === 'map'">
            <router-view v-if="$store.getters.isNavActiveTabFind"/>
            <map-stations v-if="$store.getters.isNavActiveTabFind"/>
          </div>
          <div id="afdc-mobile-results" v-if="mapListView === 'list' && isNavActiveFindModeNearest">
            <template>
              <find-nearest-results/>
            </template>
          </div>
          <div id="afdc-mobile-results" v-if="mapListView === 'list' && isNavActiveFindModeRoute">
            <directions-popup />
            <template>
              <find-route-results/>
            </template>
          </div>
      </div>

      <div id="afdc-mobile-more" role="tabpanel" aria-labelledby="afdc-mobile-more-tab" v-bind:class="{ 'afdc-tab-pane': true, 'afdc-mobile-tab-pane': true, 'afdc-show': isTabActiveMore, 'afdc-active': isTabActiveMore }">
        <footer-actions/>
      </div>
    </div>
  </div>
</template>

<script>
import FindNearestFilters from '@/components/FindNearestFilters.vue';
import FindRouteFilters from '@/components/FindRouteFilters.vue';
import FindNearestResults from '@/components/FindNearestResults.vue';
import FindRouteResults from '@/components/FindRouteResults.vue';
import MapStations from '@/components/MapStations.vue';
import syncInputRouteQuery from '@/lib/syncInputRouteQuery';
import FooterActions from '@/components/FooterActions.vue';
import EvLevelHelp from '@/components/EvLevelHelp.vue';
import FindMixin from '@/lib/FindMixin';
import DirectionsPopup from '@/components/DirectionsPopup.vue';

export default {
  mixins: [
    FindMixin,
  ],
  name: 'MobileNav',
  components: {
    FindNearestFilters,
    FindRouteFilters,
    FindNearestResults,
    FindRouteResults,
    MapStations,
    FooterActions,
    EvLevelHelp,
    DirectionsPopup,
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$store.getters.isMobileView) {
        document.querySelector('.afdc-mobile-tab-pane').style.height = `${window.innerHeight - 100}px`;
      }
    });
  },
  data() {
    return {
      activeTab: 'map',
      previousTab: '',
      mapListView: 'map',
      previousView: '',
    };
  },
  watch: {
    $route(to, from) {
      if (to.name === 'StationShow' || to.name === 'StationNew' || to.name === 'StationEdit') {
        this.openStationModal(to.name, from.name);
      } else if (from.name === 'StationShow' || from.name === 'StationNew' || from.name === 'StationEdit') {
        this.closeStationModal();
      }
    },
    '$store.getters.getFiltersFindNearest': {
      immediate: true,
      handler: 'fetchData',
    },

    '$store.getters.getFiltersFindRoute': {
      immediate: true,
      handler: 'fetchData',
    },
  },
  computed: {
    isTabActiveSearch() {
      return this.activeTab === 'search';
    },
    isTabActiveMap() {
      return this.activeTab === 'map';
    },
    isTabActiveResults() {
      return this.activeTab === 'results';
    },
    isTabActiveMore() {
      return this.activeTab === 'more';
    },
    isNpsFunded() {
      return this.$store.getters.isNpsFunded;
    },
    hasResults() {
      return this.$store.getters.hasNavStationResults;
    },
    countryOptions() {
      return this.$store.getters.loaderCountries;
    },
    queryCountry: syncInputRouteQuery('country'),

    queryAccess: syncInputRouteQuery('access'),

    mapListViewIcon() {
      if (this.mapListView === 'list') {
        return {
          icon: 'list',
          label: 'List',
        };
      } return {
        icon: 'map-marker-alt',
        label: 'Map',
      };
    },

    isNavActiveFindModeNearest() {
      return this.$store.getters.isNavActiveFindModeNearest;
    },

    isNavActiveFindModeRoute() {
      return this.$store.getters.isNavActiveFindModeRoute;
    },
    isLoading() {
      return !!(this.$store.getters.getLoadingStationPoints || this.$store.getters.getLoadingNearestStations || this.$store.getters.getLoadingRouteStations);
    },

  },
  methods: {
    // if the results view isn't in view this will get the location data for the map alone. The results component when viewable will automatically pull in the results
    fetchData() {
      if (this.mapListView === 'map' && this.isNavActiveFindModeNearest) {
        this.$store.dispatch('fetchNearestStations', this.$store.getters.getFiltersWithDefaults);
      } else if (this.isNavActiveFindModeRoute) {
        this.$store.dispatch('fetchRouteStations', this.$store.getters.getFiltersWithDefaults);
      }
    },
    submitMobileFilters() {
      this.clickTab('map');
      if (this.$store.getters.getFilterValueWithDefault('location') || this.$store.getters.getFilterValueWithDefault('start') || this.$store.getters.getFilterValueWithDefault('end')) {
        this.toggleMapListView('list');
      } else {
        this.toggleMapListView('map');
      }
    },
    clickTab(tab) {
      const tabSelect = tab === 'map' ? this.$store.commit('resizeMobileMap', true) : this.$store.commit('resizeMobileMap', false);
      const modalOpen = this.$route.name === 'StationShow' || this.$route.name === 'StationEdit' || this.$route.name === 'StationNew' || this.$route.query.show_about === true || this.$route.query.show_ev_terms === true;

      if (modalOpen) {
        this.$router.push({
          name: this.$store.getters.getNavActiveFilterRouteName,
          query: this.$store.getters.getFilters,
        });
      }
      this.activeTab = tab;
      this.previousTab = this.activeTab;
      this.$nextTick(() => {
        document.querySelector('.afdc-mobile-nav').scrollIntoView();
      });
      return tabSelect;
    },
    openStationModal(toName, fromName) {
      if (toName === 'StationEdit' && fromName === 'StationShow') {
        // don't set the previous tab and view when opening the station
        // edit form and the station details are already open
      } else {
        this.previousTab = this.activeTab;
        this.previousView = this.mapListView;
      }
      this.activeTab = 'map';
      this.mapListView = 'map';
      this.$nextTick(() => {
        document.querySelector('#afdc-alt-fuel-station').scrollIntoView();
      });
    },
    closeStationModal() {
      this.activeTab = this.previousTab;
      this.mapListView = this.previousView;
    },
    toggleMapListView(view) {
      this.mapListView = view;
    },
  },
};
</script>

<style lang="scss">
  .mobile-nav {
    position: relative;
    .clearboth {
      clear: both;
    }
    svg {
      margin-right: 5px;
    }

    #mobile-tabs {
      position: sticky;
      top: 0;
      z-index: 23;
      width: 100%;
      -moz-box-shadow:0 5px 5px rgba(132, 132, 132, 0.75);
      -webkit-box-shadow: 0 5px 5px rgba(132, 132, 132, 0.75);
      box-shadow: 0 5px 5px rgba(132, 132, 132, 0.75);
    }
    #mobile-tabs-content {
      position: relative;
    }
    .mobile-nav-item {
      width: 33.3%;
      display: flex;
      background-color: #005B82;
      justify-content: space-between;
    }
    a.mobile-nav-link {
      padding: 10px 8px 10px 4px;
      color: #bccbd2;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      &:hover,
      &:focus {
        text-decoration: none;
        color: #fff;
      }
    }
    .mobile-nav-link.active {
      text-decoration: none;
      position: relative;
      color: #fff;
      &:hover {
        text-decoration: none;
      }
      &:after {
        position: absolute;
        content: '';
        height: 2px;
        bottom: 3px;
        margin: 0 auto;
        left: 0;
        right: 0;
        width: 60%;
        background: #fff;
      }
    }

    .mobile-tab-pane {
      overflow: auto;
      padding: 10px;
      background-color: #ccc;
    }

    .map-list-toggle-btn {
      position: absolute;
      right: 5px;
      top: 10px;
      z-index: 22;
      .mobile-btn {
        padding: 5px;
        width: 50px;
        border-radius: 5px;
        background-color: #005B82;
        text-align: center;
        font-size: 12px;
        color: #fff;
        cursor: pointer;
        -webkit-box-shadow: 3px 6px 5px -5px rgba(107,106,107,1);
        -moz-box-shadow: 3px 6px 5px -5px rgba(107,106,107,1);
        box-shadow: 3px 6px 5px -5px rgba(107,106,107,1);
      }
    }

    .route-switch-row {
      display: flex;
      justify-content: center;
    }

    .station-route-switch {
      border-radius: 4px;
      border: 2px solid #005B82;
      display: flex;
      justify-content: space-between;
      margin: 15px 0 !important;
    }

    .toggle-search {
      padding: 1px;
      width: 50%;
      display: flex;
      justify-content: center;
      color: #333;
      font-size: 18px;
      &:hover {
        text-decoration: none;
      }
    }

    .toggle-search-active {
      background: #005B82;
      color: #fff;
    }

    @media(hover: hover) and (pointer: fine) {
      .map-list-toggle-btn:hover{
        color: #bccbd2;
      }
      .btn-light:hover {
        color: #212529 !important;
        background-color: #f8f9fa !important;
        border-color: #f8f9fa !important;
      }
    }

    #mobile-results {
      background-color: #ccc;
    }
    .results-tab {
      padding: 20px;
    }
    .form-control {
      height: auto;
    }
    .mobile-nav-tab-content {
      display: flex;
      align-items: center;
    }
    .mobile-results-select {
      display: flex;
      align-items: flex-start;
      margin-left: 15px;
      margin-bottom: 20px;
    }
    .mobile-results-btn {
      margin-top: 20px;
      display: flex;
      justify-content: center;
    }
    .mobile-see-results-btn {
      background-color: #005B82;
      color: #fff;
      &:hover {
        color: #bccbd2;
      }
    }
  }
</style>
